import { roles } from "../../../utils/constants";
import dayjs from "../../../utils/dayjs";

export const miutesMaximumDefault = 721;
let minutesDuration = miutesMaximumDefault * 60;

export const institutionUrgentStartMessage =
  "Désolé, il n'est pas possible de créer / modifier une prestation ayant lieu dans moins de 24h. Merci de contacter la permanence par téléphone.";

export const assertInstitutionStartNotUrgent = (start, user) => {
  if (user?.role !== roles.institution || !start) {
    return Promise.resolve();
  }

  if (start.diff(dayjs(), "hour", true) < 24) {
    return Promise.reject(new Error(institutionUrgentStartMessage));
  }

  return Promise.resolve();
};

export const validateTimeBetween = (
  refValidator,
  startKey,
  endKey,
  user,
  isLongDuration = false,
  errorNextDay = true,
) => {
  let restricted = true;
  let semiRestricted = true;

  if (user.subRoles.includes(roles.superAdmin)) {
    restricted = false;
  }

  if ([roles.admin, roles.permanance].includes(user.role)) {
    semiRestricted = false;
  }

  let values = refValidator.getFieldsValue(true);
  let start = values[startKey];
  let end = values[endKey];

  if (start === undefined || end === undefined) {
    return Promise.reject(
      new Error("Merci d'indiquer une date et heure de début et de fin"),
    );
  }

  // Calculate the total duration in seconds
  const durationSeconds = end.diff(start, "second");

  if (durationSeconds < 0) {
    return Promise.reject(new Error("La durée ne peut être négative"));
  }

  if (restricted) {
    let tomorrow = dayjs()
      .add(1, "day")
      .startOf("day"); // On calcule le début de la journée suivante

    // Vérifier que la date de début est pour demain ou plus tard
    if (start.isBefore(tomorrow) && errorNextDay && semiRestricted) {
      return Promise.reject(
        new Error("Commande possible uniquement pour le jour suivant"),
      );
    }

    // Vérifier que la durrée n'est pas plus de 6 heures
    if (durationSeconds >= minutesDuration) {
      return Promise.reject("La durée doit être moins de  12 heures.");
    }
  }

  return Promise.resolve();
};

export const disabledDatePast = current => {
  // Rule 1: Not in past
  return current && current < dayjs().endOf("day");
};

export const disabledDateNext12Months = current => {
  // Rule: Disable dates more than 12 months in the future
  return (
    current &&
    current >
      dayjs()
        .add(12, "month")
        .endOf("day")
  );
};

/**
 * Capitalisation pour noms / adresses (utilisée au blur pour éviter le reset du curseur).
 */
function titleCaseHyphenated(word) {
  return word
    .split("-")
    .map(part =>
      part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : part,
    )
    .join("-");
}

export function smartCapitalize(str) {
  if (!str) return str;

  const words = str.split(/\s+/);

  if (words[0]) {
    words[0] = titleCaseHyphenated(words[0]);
  }

  for (let i = 1; i < words.length; i++) {
    const w = words[i];
    if (!w) continue;

    const first = w.charAt(0);

    if (w === w.toUpperCase() || first === first.toUpperCase()) {
      words[i] = titleCaseHyphenated(w);
    } else {
      words[i] = w;
    }
  }

  return words.join(" ");
}

export const normalizeString = (str = "") =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const customSearchSelect = () => {};
